import { useCallback } from 'react';
import { useAsyncEffect } from 'react-utils/hooks/useAsyncEffect';
import { MagpieConnection } from 'magpie-lib/connection';
import { UtilityMessages, utilityTopicDef } from '../topics/utility';
import { navigate } from '../../utils/common';
import { waitForConnectedMagpie } from '../../utils/magpie';

export const useHostNavigate = () => {
  const sendHostNavigateMessage = useCallback(
    (location: string, newTab = false) => {
      const connection = MagpieConnection.get();
      const message = UtilityMessages.hostNavigateMessage.create({
        location,
        newTab,
      });
      connection.useTopic(utilityTopicDef).publish(message);
    },
    []
  );
  return sendHostNavigateMessage;
};

export const useRegisterHostNavigate = () => {
  useAsyncEffect(async () => {
    await waitForConnectedMagpie();
    const connection = MagpieConnection.get();
    const unsubscribe = connection
      .useTopic(utilityTopicDef)
      .on(UtilityMessages.hostNavigateMessage.getType(), (message) => {
        const { location, newTab } = message.payload;
        navigate(location, newTab);
      });
    return () => unsubscribe();
  }, []);
};
